import { Component, Output, EventEmitter } from '@angular/core';

export enum ToasterIntent {
  INFO = 'information',
  SUCCESS = 'success',
  DANGER = 'danger',
  DECOMMISSION = 'decommission',
}

export type ToasterOptions = {
  intent?: ToasterIntent;
  intentIcon?: string;
  subtext?: string;
  description?: string;
  linkLabel?: string;
  hasClose?: boolean;
  duration?: number;
};

@Component({
  moduleId: module.id,
  selector: 'toaster',
  templateUrl: './toaster.component.html',
})
export class ToasterComponent {
  @Output() action = new EventEmitter<any>();
  isOpen: boolean = false;
  isDecommission: boolean = false;
  /**
   * The type of feedback
   */
  intent: string = ToasterIntent.SUCCESS;
  /**
   * Icon that conveys the intent in a visual manner
   */
  intentIcon = 'confirm-small';
  /**
   * The title of the message
   */
  title: string = '';
  /**
   * The text displayed on the action button
   */
  linkLabel: string = '';
  /**
   * The description of the message
   */
  description: string = '';
  /**
   * The subtext of the message
   */
  subtext: string = '';
  /**
   * When true, displays a close icon button inside of the toast
   */
  hasCloseButton: boolean = true;
  /**
   * When true, displays an action button inside of the toast
   */
  hasActionLink: boolean = false;

  protected autoCloseTimer: ReturnType<typeof setTimeout>;

  notify(title: string, options?: ToasterOptions): void {
    this.title = title;

    // Initialize options
    this.description = options.description;
    this.linkLabel = options.linkLabel;
    this.hasCloseButton = options.hasClose !== undefined ? options.hasClose : this.hasCloseButton;
    this.subtext = options.subtext;

    // Defaults
    this.hasActionLink = options.linkLabel ? true : false;

    if (options.duration) {
      this.setupAutoClose(options.duration);
    }

    if (options.intent) {
      this.intent = options.intent;
      this.isDecommission = this.intent === ToasterIntent.DECOMMISSION;
    }
    if (options.intentIcon) {
      this.intentIcon = options.intentIcon;
    }

    this.open();
  }

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
    this.isOpen = false;
  }

  setupAutoClose(delay: number) {
    this.autoCloseTimer = setTimeout(() => this.close(), delay);
  }

  performAction(): void {
    this.action.emit();
  }
}
